import { SortDispositionSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-disposition";
import { SortDestinationForeground } from "@redotech/redo-fulfillment-wms-common/sort-destination-display";
import { processingSessionItemIdFormat } from "@redotech/redo-return-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const SortDestinationDisplaySchema = z.object({
  label: z.string(),
  color: z.string(),
  foreground: z.enum([
    SortDestinationForeground.light,
    SortDestinationForeground.dark,
  ]),
  placeholder: z.boolean(),
  detail: z.string().optional(),
});
export type SortDestinationDisplay = z.infer<
  typeof SortDestinationDisplaySchema
>;

export const getProcessingSessionSortDestinations = {
  name: "getProcessingSessionSortDestinations" as const,
  input: z.object({
    returnId: zExt.objectId(),
    // Identifies the operator's station so the per-item destination reflects the
    // bound tote completion will route into. Absent falls back to
    // single-open-session-at-location detection (same as completion).
    workstationId: z.string().optional(),
  }),
  output: z.object({
    sessionDestination: SortDestinationDisplaySchema.nullable(),
    itemDestinations: z.record(
      processingSessionItemIdFormat.schema,
      SortDestinationDisplaySchema.nullable(),
    ),
    unboundDisposition: SortDispositionSchema.nullable(),
    /**
     * Session items the warehouse still owes work on. Their destination is the
     * Needs Work bucket, and the operator is told why rather than sorting.
     */
    workRequestedItemIds: z.array(processingSessionItemIdFormat.schema),
    /** Set when any unit on the return has open work. */
    returnHasWorkRequested: z.boolean(),
  }),
};

export type GetProcessingSessionSortDestinationsResult = z.infer<
  typeof getProcessingSessionSortDestinations.output
>;
